export default "__VITE_ASSET__CsrlPcmh__"